module.exports = __webpack_public_path__ + "assets/feature1-c09d4b71f91271b45a80458ac93fcca3.svg";